import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FazerPedidoIntegralService {

  constructor(private readonly http : HttpClient) { }

  public getAllEmpresas (idEmpresa) {  
    return this.http.get( `/apiconnect/importation/company/updated-users/${idEmpresa}/companies?diasAnteriores=15` );  
  }

  public getCalculationCounterStatus (idEmpresa) {  
    return this.http.get( `/apiconnect/orders/calculations/companies/${idEmpresa}/counter-status` );  
  }

  public getAllEmpresasWithCalculationStatus (idEmpresa, filtro) {  
    return this.http.get( `/apiconnect/orders/calculations/companies/${idEmpresa}/status?filter=${filtro}` );  
  }
}
